// How exactly a criterion matches a searched word, its case and accents always ignored.
export enum SearchTolerance {
  // The text contains the word as typed.
  Exact = 'Exact',
  // One typo from 5 letters on.
  Near = 'Near',
  // One typo from 4 letters on, two from 8.
  Approximate = 'Approximate',
}

// The word lengths from which each tolerance allows one more typo.
const TYPO_THRESHOLDS: Readonly<Record<SearchTolerance, readonly number[]>> = {
  [SearchTolerance.Exact]: [],
  [SearchTolerance.Near]: [5],
  [SearchTolerance.Approximate]: [4, 8],
};

export const SEARCH_TOLERANCE_LABELS: Readonly<
  Record<SearchTolerance, string>
> = {
  [SearchTolerance.Exact]: 'orthographe exacte',
  [SearchTolerance.Near]: '1 faute tolérée à partir de 5 lettres',
  [SearchTolerance.Approximate]: 'fautes de frappe tolérées',
};

export const toleratedTyposOf = (
  word: string,
  tolerance: SearchTolerance,
): number =>
  TYPO_THRESHOLDS[tolerance].filter((length) => word.length >= length).length;
